import React from 'react'
import Link from 'next/link'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { forgetpasswordSchema } from '@/src/types'
import { ArrowIcon } from '@/src/assets/icons'
import { FormTextField } from '../form-components'
import Button from '../button'
import { TextField, Typography } from '@mui/material'

interface FormData {
  email: string
}

export interface Props {
  loading: boolean
  onSubmit: (formData: FormData) => void
}

const ForgotPasswordForm = ({ loading, onSubmit }: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<FormData>({ resolver: yupResolver(forgetpasswordSchema) })

  const formSubmit = (data: FormData) => {
    onSubmit(data)
  }

  return (
    <div className="flex flex-col items-center gap-4">
      <form className="flex flex-col gap-2 " onSubmit={handleSubmit(formSubmit)}>
        <TextField
          label={'Email Address'}
          {...register('email')}
          variant="outlined"
          autoComplete="off"
          placeholder={'Email Address'}
          error={!!errors.email}
          helperText={errors.email?.message}
          fullWidth
          InputProps={{
            className: `rounded-[0.625rem] border-icon-darkgray w-[20.438rem] sm:w-[26.5rem] `
          }}
          InputLabelProps={{
            className: 'text-secondary-main'
          }}
        />
        <Button
          text="Continue"
          divClass="mt-6"
          fullwidth={true}
          loading={loading}
          type="submit"
          onClick={() => {}}
        />
      </form>
      <div className="flex justify-start w-full gap-4 items-center mt-4">
        <Link
          href="/login"
          className="!text-left flex gap-2"
          data-testid="automation-IRHQ_ResetPassword-BacktoSignInpage"
        >
          <ArrowIcon className="rotate-180 transform fill-primary-main w-2 fill-red-8 stroke-2 hover:fill-primary-main transition-all duration-600" />
          <Typography variant="buttonLarge_lg" color="primary.main">
            Back to Sign In page
          </Typography>
        </Link>
      </div>
    </div>
  )
}

export default ForgotPasswordForm
